import { Component } from "@angular/core";
import { MeetingAgendaItemComponent } from "@org-common/lib/meetings/meeting-agenda-component-registry";
import { TourIdentifier } from "../../../tours/tour-identifier.enum";

@MeetingAgendaItemComponent("adapt-annual-objectives-key-results-agenda-item")
@Component({
    selector: "adapt-annual-objectives-key-results-agenda-item",
    templateUrl: "./annual-objectives-key-results-agenda-item.component.html",
    standalone: false,
})
export class AnnualObjectivesKeyResultsAgendaItemComponent {
    public readonly PageActivationTours = [TourIdentifier.CreateKeyResultsForObjectiveFeatureTour];
}
